// Helper function to process video accessibility for a container
function processVideoAccessibility(container, containerName) {
  const lsVideo = container.querySelector('#ls-video');
  
  if (lsVideo && !lsVideo.hasAttribute('aria-labelledby')) {
    lsVideo.setAttribute('aria-labelledby', 'ls-detail-caption');
    
    const lsDetailCaption = document.querySelector('.ls-detail-caption');
    if (lsDetailCaption) {
      lsDetailCaption.setAttribute('id', 'ls-detail-caption');
    }
  }
}

// Function to handle accessibility attributes
function handleLsVideoAccessibility() {
  const containers = [
    { selector: '#ls-slider-popup-container', name: '#ls-slider-popup-container' },
    { selector: '#ls-popup-container', name: '#ls-popup-container' }
  ];
  
  containers.forEach(({ selector, name }) => {
    const container = document.querySelector(selector);
    if (container) {
      processVideoAccessibility(container, name);
    }
  });
}

// Dynamically inject/remove the loading announcement text in the predictive-search
// live region. Static content already present in the DOM when a live region becomes
// visible is never announced by screen readers — only newly added content is.
(function () {
  function syncLoadingAnnouncement(el) {
    var announcement = el.querySelector('.js-loading-announcement');
    if (!el.hasAttribute('hidden')) {
      if (!announcement) {
        var span = document.createElement('span');
        span.className = 'visually-hidden js-loading-announcement';
        span.textContent = el.dataset.loadingText || 'Loading search results';
        el.appendChild(span);
      }
    } else if (announcement) {
      announcement.remove();
    }
  }

  function attachLoadingObserver(el) {
    if (el.dataset.loadingObserverAttached) return;
    el.dataset.loadingObserverAttached = 'true';
    new MutationObserver(function () {
      syncLoadingAnnouncement(el);
    }).observe(el, { attributes: true, attributeFilter: ['hidden'] });
  }

  function initLoadingAnnouncements() {
    document.querySelectorAll('.predictive-search__loading-state').forEach(attachLoadingObserver);
  }

  initLoadingAnnouncements();
  new MutationObserver(initLoadingAnnouncements).observe(document.body, { childList: true, subtree: true });
})();

// Watch for #ls-slider-popup-container
const lsSliderObserver = new MutationObserver((mutations) => {
  handleLsVideoAccessibility();
});

lsSliderObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// Update Flickity page dots aria-labels from 'Page dot' to 'Slide', and set ARIA roles
function updateFlickityDotsAriaLabels() {
  const containers = document.querySelectorAll('.flickitylf-page-dots');
  containers.forEach((container) => {
    if (!container.hasAttribute('role')) {
      container.setAttribute('role', 'presentation');
    }
  });

  const dots = document.querySelectorAll('.flickitylf-page-dots .dot');
  dots.forEach((dot) => {
    if (!dot.hasAttribute('role')) {
      dot.setAttribute('role', 'button');
    }
    const ariaLabel = dot.getAttribute('aria-label');
    if (ariaLabel && ariaLabel.includes('Page dot')) {
      dot.setAttribute('aria-label', ariaLabel.replace('Page dot', 'Slide'));
    }
  });
}

// Run on page load
updateFlickityDotsAriaLabels();

// Watch for dynamically added dots
let flickityDotsUpdateScheduled = false;
const flickityDotsObserver = new MutationObserver(() => {
  if (flickityDotsUpdateScheduled) return;
  flickityDotsUpdateScheduled = true;
  requestAnimationFrame(() => {
    flickityDotsUpdateScheduled = false;
    updateFlickityDotsAriaLabels();
  });
});

flickityDotsObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// Sync tabindex on focusable children whenever a carousel cell's aria-hidden changes.
// Flickity sets aria-hidden="true" on non-selected cells but leaves their focusable
// descendants keyboard-reachable, causing WCAG SC 1.3.1 / 4.1.2 violations.
(function () {
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';

  function syncCellFocusability(cell) {
    var hidden = cell.getAttribute('aria-hidden') === 'true';
    cell.querySelectorAll(FOCUSABLE).forEach(function (el) {
      if (hidden) {
        if (!el.hasAttribute('data-tabindex-saved')) {
          var orig = el.getAttribute('tabindex');
          el.setAttribute('data-tabindex-saved', orig !== null ? orig : '');
        }
        el.setAttribute('tabindex', '-1');
      } else if (el.hasAttribute('data-tabindex-saved')) {
        var saved = el.getAttribute('data-tabindex-saved');
        if (saved === '') {
          el.removeAttribute('tabindex');
        } else {
          el.setAttribute('tabindex', saved);
        }
        el.removeAttribute('data-tabindex-saved');
      }
    });
  }

  function attachCellObserver(cell) {
    if (cell.dataset.ariaHiddenGuard) return;
    cell.dataset.ariaHiddenGuard = 'true';
    syncCellFocusability(cell);
    new MutationObserver(function () {
      syncCellFocusability(cell);
    }).observe(cell, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  function attachToAllCells() {
    document.querySelectorAll('.carousel-cell').forEach(attachCellObserver);
  }

  attachToAllCells();

  new MutationObserver(attachToAllCells).observe(document.body, {
    childList: true,
    subtree: true,
  });
})();

// Add focus class to kt-image-item-box when kt-image-link is focused
function setupImageLinkFocus() {
  document.querySelectorAll('.kt-image-link, .kt-image-lightbox').forEach((link) => {
    if (link.dataset.focusListenerAdded) return;
    link.dataset.focusListenerAdded = 'true';
    
    link.addEventListener('focus', () => {
      const parent = link.closest('.kt-image-item-box');
      if (parent) parent.classList.add('has-focus-within');
    });
    
    link.addEventListener('blur', () => {
      const parent = link.closest('.kt-image-item-box');
      if (parent) parent.classList.remove('has-focus-within');
    });
  });
}

// Run on page load
setupImageLinkFocus();

// Watch for dynamically added links
const imageLinkObserver = new MutationObserver(() => {
  setupImageLinkFocus();
});

imageLinkObserver.observe(document.body, {
  childList: true,
  subtree: true
});


